import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity, mapToFormData } from './mapper';
import { PropertyType } from '../../../common';

export const editTemplate = (data: PropertyType): Promise<PropertyType> =>
	api.post('/user/update-report-filter-template', mapToFormData(mapEntityToApi(data)), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data.data);
	});
